import { CurrentLang } from 'common/';
import MagstimTable from './MagstimTable';

class MagstimTableMTHistory extends MagstimTable {

	initForSelect = (data) => {
		this.initTable(this.configTableMTHistoryData(data), true);
	}

	initForEdit = (data) => {
		this.initTable(this.configTableMTHistoryData(data), true);
	}

	configTableMTHistoryData(data) {
		return {
			columns: [
				{ title: CurrentLang().report_column_header_motor_thresholds_assessed_date, property: 'treatmentDate', isSearchable: true, formatter: this.formatDateAndTime },
				{ title: CurrentLang().treatment_summary_card_pcRMT, property: 'rMTLevel' },
				
				{ title: CurrentLang().device, property: 'deviceUsed', isSearchable: true },
				{ title: CurrentLang().treatment_history_table_device_guid, property: 'deviceUsedGuid', isExportOnly: true, optional: true },
				
				{ title: CurrentLang().treatment_history_table_managing_physician_name, property: 'managingPhysician', isExportOnly: true, optional: true },
				{ title: CurrentLang().treatment_history_table_managing_physician_email, property: 'managingPhysicianEmail', isExportOnly: true, optional: true },
				{ title: CurrentLang().treatment_history_table_managing_physician_guid, property: 'managingPhysicianGuid', isExportOnly: true, optional: true },
				
				{ title: CurrentLang().treatment_history_table_referring_physician_name, property: 'referringPhysician', isExportOnly: true, optional: true },
				{ title: CurrentLang().treatment_history_table_referring_physician_email, property: 'referringPhysicianEmail', isExportOnly: true, optional: true },
				{ title: CurrentLang().treatment_history_table_referring_physician_guid, property: 'referringPhysicianGuid', isExportOnly: true, optional: true },
				
				{ title: CurrentLang().treatment_history_table_columnname_performedBy, property: 'clinician', isSearchable: true }
			],
			data: data
		};
	}

	resetFilters() {
		//console.log('MagstimTableMTHistory.reset');
		super.resetFilters();

		// this.addFilter('clinician', 'Bob');
		// this.addFilter('treatmentDate', '2019');
	}
}

export default MagstimTableMTHistory;